<template>
  <v-dialog v-model="dialog" width="500">
    <v-card class="pa-0">
      <v-card-title>
        {{ title }}
      </v-card-title>

      <v-card-text class="black--text">
        {{ description }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          rounded
          height="40"
          width="100"
          @click="$emit('close')"
        >
          {{ textCloseButton ? textCloseButton : "Fechar" }}
        </v-btn>
        <v-btn
          v-if="textConfirmButton"
          color="primary"
          rounded
          depressed
          class="ml-2"
          height="40"
          width="100"
          :loading="loading"
          @click="$emit('confirm')"
        >
          {{ textConfirmButton ? textConfirmButton : "Confirmar" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: [
    "title",
    "description",
    "textConfirmButton",
    "textCloseButton",
    "show",
    "loading",
  ],
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    show(v) {
      this.dialog = v;
    },
  },
};
</script>
